import { mapGetters } from "vuex";

export const toggleModals = {

  mounted() {
    if (process.env.NODE_ENV === 'development') {
      console.log('modal.js mixin is mounted');
    }
    // Replace Native Device Back Button/Function with an in-app function
  },
  watch: {
    $route() {
      this.$store.dispatch("ui/closeAllModals")
    },
    isOverflow(val) {
      this.setOverflow(val)
    }
  },
  computed: {
    ...mapGetters({
      // isGoBack: 'ui/isGoBack',
      showBuyModal: 'ui/showBuyModal',
      showSignInModal: 'ui/showSignInModal',
      showPaymentModal: 'ui/showPaymentModal',
      showTicketModal: 'ui/showTicketModal',
      isRouteLocked: "ui/isRouteLocked"
    }),
    isOverflow() {
      return this.showBuyModal || this.showSignInModal || this.showTicketModal
    },

  },
  methods: {
    setOverflow(val) {
      console.log('set overflow');
      if (val) {
        this.$store.commit("ui/SET_ROUTE_LOCK", true);
        document.querySelector("html").style.overflow = "hidden";
      } else {
        // this.$store.commit("ui/SET_ROUTE_LOCK", false);
        document.querySelector("html").style.overflow = "auto";
      }
    },



  }
}